import { matchPath } from 'react-router-dom';

import { projectPaths } from 'app/routes/paths/project';

// Exported so NodeDetailsPanelRoutes can reuse the exact same route shape for the flag-off (legacy
// drawer) case instead of hand-duplicating it — the two must never drift apart.
export const treeDetailRoutePaths = [
  `${projectPaths.BASE}/data/nodes/:templateNodeId/tree/d/:id/details`,
  `${projectPaths.PROPOSAL}/data/nodes/:templateNodeId/tree/d/:id/details`
] as const;

// Exported so useCloseNodeDetailsPanel can reuse the exact same route shape instead of
// hand-duplicating it — the two must never drift apart.
export const treeBaseRoutePaths = [
  `${projectPaths.BASE}/data/nodes/:templateNodeId/tree`,
  `${projectPaths.PROPOSAL}/data/nodes/:templateNodeId/tree`
] as const;

export type TreeNodeDetailsRouteParams = {
  projectId: string;
  templateNodeId: string;
  id: string;
  proposalId?: string;
};

export const matchTreeNodeDetailsPath = (pathname: string) =>
  matchPath<TreeNodeDetailsRouteParams>(pathname, { path: treeDetailRoutePaths });

/** Matches NewTreeView detail routes (`.../data/nodes/:id/tree/d/:id/details`). */
export const isTreeNodeDetailsPath = (pathname: string): boolean => matchTreeNodeDetailsPath(pathname) !== null;

export const matchTreeBasePath = (pathname: string) => matchPath(pathname, { path: treeBaseRoutePaths });
